import { helper } from '@ember/component/helper'

interface Signature {
  Args: {
    Positional: [val: unknown[], separator: string | undefined]
  }
  Return: string
}
export const joinList = helper<Signature>(function (params: [unknown[], string?]) {
  const [collection, separator] = params

  return collection.join(separator)
})

export default joinList
